const TriangleSvg = ({ color = "#081F43", width = 20, height = 15 }) => (
  <svg width={width} height={height} viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg">
    <polygon points="10,0 20,15 0,15" fill={color} />
  </svg>
);
export default TriangleSvg;